// Dependencies
import React from "react";

// Material UI Components
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Skeleton from "@mui/material/Skeleton";
import Link from "@mui/material/Link";

// Components

// Helpers
import { inventoryRoute } from "routes";

// Styles
import { useStyles } from "./SimilarVehicles.styles";

const SimilarVehicles = ({ navRef }) => {
  const classes = useStyles();

  // Placeholder data - replace with query results
  const isLoading = false;
  const similarVehicles = [
    { id: 1, make: "Honda", model: "Civic" },
    { id: 2, make: "Ford", model: "Focus" },
    { id: 3, make: "Audi", model: "A4" },
    { id: 4, make: "Kia", model: "Forte" },
    { id: 6, make: "Toyota", model: "Corolla" },
    { id: 7, make: "Chevrolet", model: "Malibu" },
  ];

  const loaders = () => [
    <Skeleton variant="text" key="similar-vehicle-placeholder-1" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-2" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-3" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-4" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-5" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-6" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-7" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-8" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-9" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-10" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-11" />,
    <Skeleton variant="text" key="similar-vehicle-placeholder-12" />,
  ];

  const displaySimilarVehicles = () => {
    if (isLoading) {
      return loaders();
    }
    return similarVehicles.map((vehicle) => (
      <Link
        className={classes.similarVehicleLinks}
        key={`${vehicle.make}-${vehicle.model}`}
        href={`${inventoryRoute}/${vehicle.make}/${vehicle.model}`}
      >
        <Typography className={classes.nearbyVehicleMake}>
          {vehicle.make}
        </Typography>
        <Typography className={classes.nearbyVehicleModel}>
          {vehicle.model}
        </Typography>
      </Link>
    ));
  };

  return (
    <Container
      ref={navRef}
      className={classes.container}
      maxWidth="lg"
      data-component="SimilarVehicles"
    >
      <Typography
        variant="h2"
        className={classes.similarVehiclesTitle}
        data-cy="similar-vehicles"
      >
        Similar Vehicles
      </Typography>
      <Grid container spacing={2}>
        {displaySimilarVehicles().map((vehicleElement) => (
          <Grid
            item
            md={2}
            xs={4}
            key={`similar-vehicles-${vehicleElement.id}`}
          >
            {vehicleElement}
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default SimilarVehicles;
